module.exports = __webpack_public_path__ + "img/portrait-062.a3f9cd7d.jpg";